import { render, staticRenderFns } from "./FormBand.vue?vue&type=template&id=5055a9e4&"
import script from "./FormBand.vue?vue&type=script&lang=js&"
export * from "./FormBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports